module.exports = __webpack_public_path__ + "static/media/lunch2.81949c50.png";